import './styles.css';
import { initContactForm } from './contact-form';

initContactForm();
